import React from "react";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import FloatingIcons from "./components/FloatingIcons";

const Contact = () => {
  return (
    <>
    <title>تواصل معنا | مؤسسة محمد إبراهيم أبة عدبه للمحاماة والأستشاارت القانونية</title>
      <Nav />
      <FloatingIcons />

      <section
        className="contact"
        style={{
          paddingTop: "150px",
          paddingBottom: "100px",
          background: "linear-gradient(135deg, #1e3a1e, #29521e)",
          color: "#fff",
          fontFamily: "Cairo, sans-serif",
        }}
      >
        <div
          className="container"
          style={{
            width: "90%",
            maxWidth: "1100px",
            margin: "0 auto",
            textAlign: "center",
          }}
        >
          {/* العنوان */}
          <div
            className="mainTitle"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "15px",
              marginBottom: "60px",
            }}
          >
            <h2
              style={{
                fontSize: "2rem",
                fontWeight: "bold",
                textAlign: "center",
                color: "#fff",
              }}
            >
              تواصل معنا
            </h2>
          </div>

          {/* معلومات التواصل */}
          <div
            className="contact-info"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
              gap: "30px",
              justifyContent: "center",
            }}
          >
            <div
              className="box"
              style={{
                background: "rgba(255,255,255,0.1)",
                padding: "30px",
                borderRadius: "16px",
                boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                transition: "0.3s",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.background = "rgba(255,255,255,0.2)")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.background = "rgba(255,255,255,0.1)")
              }
            >
              <h3 style={{ marginBottom: "15px", fontSize: "20px" }}>
                📍 العنوان
              </h3>
              <p>8 عمارات أول مايو - مدينة نصر - القاهرة</p>
            </div>

            <div
              className="box"
              style={{
                background: "rgba(255,255,255,0.1)",
                padding: "30px",
                borderRadius: "16px",
                boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                transition: "0.3s",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.background = "rgba(255,255,255,0.2)")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.background = "rgba(255,255,255,0.1)")
              }
            >
              <h3 style={{ marginBottom: "15px", fontSize: "20px" }}>
                ☎️ أرقام التواصل
              </h3>
              <p>01113318804</p>
            </div>

            <div
              className="box"
              style={{
                background: "rgba(255,255,255,0.1)",
                padding: "30px",
                borderRadius: "16px",
                boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                transition: "0.3s",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.background = "rgba(255,255,255,0.2)")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.background = "rgba(255,255,255,0.1)")
              }
            >
              <h3 style={{ marginBottom: "15px", fontSize: "20px" }}>
                📧 البريد الإلكتروني
              </h3>
              <p>info@mohamedadba.com</p>
            </div>

            <div
              className="box"
              style={{
                background: "rgba(255,255,255,0.1)",
                padding: "30px",
                borderRadius: "16px",
                boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                transition: "0.3s",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.background = "rgba(255,255,255,0.2)")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.background = "rgba(255,255,255,0.1)")
              }
            >
              <h3 style={{ marginBottom: "15px", fontSize: "20px" }}>
                ⏰ مواعيد العمل
              </h3>
              <p>من السبت إلى الأربعاء</p>
              <p>من 5 مساءا حتى 10 مساءً</p>
              <p>الجمعة إجازة</p>
            </div>
          </div>

          {/* خريطة صغيرة اختيارية */}
          <div style={{ marginTop: "60px" }}>
            <iframe
              title="موقع المكتب"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d215.80621785050647!2d31.33991027268315!3d30.06841552689578!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14583f0048d1e2bf%3A0xc4c63299a08a1afc!2z2LnZhdin2LHYp9iq!5e0!3m2!1sen!2seg!4v1762023438783!5m2!1sen!2seg"
              width="100%"
              height="350"
              style={{
                border: 0,
                borderRadius: "16px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
              }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Contact;
